import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const { REACT_APP_ClientKey, REACT_APP_VERSION } = process.env;

function SenyoError() {
  const clientKey = `${REACT_APP_ClientKey}`;

  //States
  const [captcha, setCaptcha] = useState(true);

  //Remove user data from Session as an error occurred
  useEffect(() => {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('idToken');
  }, []);

  if (captcha) {
    return (
      <div>
        <div className="container">
          <div className="row mt-5">
            <div className="col-3">
              <img alt="logo" src="/assets/Logos/AppIcon.png" />
            </div>
            <div className="col"></div>
          </div>
          <div className="row mt-5">
            <div className="col-3"></div>
            <div className="col">
              <h1>Oops!</h1>
              <h1>Something went wrong :(</h1>
              <div className="input-group mb-3">
                <p>
                  Please try again by{' '}
                  <Link to="/signin" className="linkClickHere">
                    clicking here
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="col-3"></div>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '0', right: '1%' }}>
          <p>v{REACT_APP_VERSION}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '40%', top: '40%' }}>
        <div>
          <ReCAPTCHA
            sitekey={clientKey}
            onChange={() => {
              setCaptcha(true);
            }}
          />
        </div>
      </div>
    );
  }
}

export default SenyoError;
